import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { clasesApi } from '@/data/api/clasesApi';
const KEY = 'clases';
export function useClasesDelDia(filtros) {
    return useQuery({
        queryKey: [KEY, 'dia', filtros],
        queryFn: () => clasesApi.listar(filtros),
        placeholderData: (previous) => previous,
    });
}
export function useMisClases(desde, hasta) {
    return useQuery({
        queryKey: [KEY, 'mis-clases', desde, hasta],
        queryFn: () => clasesApi.misClases(desde, hasta),
        placeholderData: (previous) => previous,
    });
}
export function useClase(id) {
    return useQuery({
        queryKey: [KEY, 'detalle', id],
        queryFn: () => clasesApi.ver(id),
        enabled: Boolean(id),
    });
}
function invalidarTodo(qc) {
    qc.invalidateQueries({ queryKey: [KEY] });
    qc.invalidateQueries({ queryKey: ['reservas'] });
    qc.invalidateQueries({ queryKey: ['dashboard'] });
}
export function useEditarClase() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, datos, }) => clasesApi.editar(id, datos),
        onSuccess: () => invalidarTodo(qc),
    });
}
export function useAsignarEmpleadoClase() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, empleadoId, motivo, }) => clasesApi.asignarEmpleado(id, empleadoId, motivo),
        onSuccess: () => invalidarTodo(qc),
    });
}
export function useCambiarEmpleadoClase() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, empleadoId, motivo, }) => clasesApi.cambiarEmpleado(id, empleadoId, motivo),
        onSuccess: () => invalidarTodo(qc),
    });
}
export function useDesasignarClase() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, motivo }) => clasesApi.desasignarEmpleado(id, motivo),
        onSuccess: () => invalidarTodo(qc),
    });
}
export function useMarcarDictada() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => clasesApi.marcarDictada(id),
        onSuccess: () => invalidarTodo(qc),
    });
}
export function useCancelarClase() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, motivo }) => clasesApi.cancelar(id, motivo),
        onSuccess: () => invalidarTodo(qc),
    });
}
export function useAplicarPrecioOverride() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, monto, motivo, stepUpToken, }) => clasesApi.aplicarPrecioOverride(id, { monto, motivo, stepUpToken }),
        onSuccess: () => invalidarTodo(qc),
    });
}
